
import { FriendlyNumberConfig } from "@/models/dossier-configs/friendly-number-config";
import { JournalConfig } from "@/models/dossier-configs/journal-config";
import Vue from "vue";
import AppFriendlyIdEdit from "./FriendlyIdEdit.vue";
import { ISelectItem } from "winfakt-vue-components";
import { PurchaseService, SaleService } from "@/services";
import AppAskNextNumber from "./ResetNumberingAskForNextNumber.vue";
import { PromisifyModal } from "@/utils/promisify-modal";

export default Vue.extend({
	data(){
		return {
			toEditJournal: new JournalConfig(),
			sellNumberConfig: new FriendlyNumberConfig(),
			purchaseNumberConfig: new FriendlyNumberConfig(),
			askNextNumberModalData: new PromisifyModal<number>()

		};
	},
	props: {
		value: {
			type: Object as ()=>JournalConfig,
			required: true
		},
		journalId: {
			type: Number,
			required: true
		}
	},
	computed: {
		buttonBarItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("reset-sale-journal-numbers"),
					value: this.resetSaleNumbers.bind(this)
				},
				{
					text: this.$ct("reset-purchase-journal-numbers"),
					value: this.resetPurchaseJournalNumbers.bind(this)
				}
			];
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.toEditJournal = new JournalConfig(this.value.getJSON());
				if (this.toEditJournal.PurchaseFriendlyNumberConfig) {
					this.purchaseNumberConfig = this.toEditJournal.PurchaseFriendlyNumberConfig;
				}
				if (this.toEditJournal.SellFriendlyNumberConfig) {
					this.sellNumberConfig = this.toEditJournal.SellFriendlyNumberConfig;
				}
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm() {
			this.$emit("input", new JournalConfig(this.toEditJournal.getJSON()));
			this.close();
		},
		onSellFriendlyNumberConfigToggle(value:boolean){
			if (!value) {
				this.toEditJournal.SellFriendlyNumberConfig = null;
			}else{
				this.toEditJournal.SellFriendlyNumberConfig = this.sellNumberConfig;
			}
		},
		onPurchaseFriendlyNumberConfigToggle(value:boolean){
			if (!value) {
				this.toEditJournal.PurchaseFriendlyNumberConfig = null;
			}else{
				this.toEditJournal.PurchaseFriendlyNumberConfig = this.purchaseNumberConfig;
			}
		},
		async resetSaleNumbers(){
			let newNumber = await this.askNextNumberModalData.show();
			let message = this.$ct("are-you-sure-you-want-to-reset-sale-journal-numbering", {journal: this.journalId});
			let result = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!result) return;
			await SaleService.fixFriendlyIds(1, this.journalId, newNumber);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		},
		async resetPurchaseJournalNumbers(){
			let message = this.$ct("are-you-sure-you-want-to-reset-purchase-journal-numbering", {journal: this.journalId});
			let result = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!result) return;
			await PurchaseService.resetNumbering(this.journalId);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		}
	},
	components: {
		AppFriendlyIdEdit,
		AppAskNextNumber
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
